import React from 'react'
import cx from 'classnames'

import Small from '../Small'
import styles from './FormError.module.css'

const FormError = ({ className, ...rest }) => {
  return (
    <div className={cx(styles.Container, className)}>
      <Small {...rest} />
    </div>
  )
}

export default FormError
